function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { useHistory } from 'react-router';
import { Autocomplete, Button, Card, ConfirmationModal, Page, Typography, useOverlayContext } from 'seagull';
import { routes } from "../../../constants";
import { selectors } from "../../../store/state-selectors";
import { useOnMount } from "../../../hooks/useOnMount";
import { getPMDetails } from "../pm.utils";
import ExternalLinkButton from "../../../components/ExternalLinkButton";
import { integrationModel } from "../../../models";
import { useStore, useStoreActions } from "../../../contexts";
import { handlePromise } from "../../../infra/utils";
import PMMapServicesModal from "../PMMapServicesModal/PMMapServicesModal";
import { PracticeManagement, isPracticeManagementIntegrationItem } from "../../../types/api.model";
import styles from "./PMSetupPage.module.scss";
import { jsxs as _jsxs, jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
export default function PMSetupPage(props) {
  const {
    pmName,
    testid,
    integration,
    getItems,
    doDisconnect,
    linkServiceTemplate,
    getServiceTemplateIntegratedIds
  } = props;
  const history = useHistory();
  const {
    fetchIntegrations,
    fetchKarbonIntegration,
    fetchKarbonUsers,
    api
  } = useStoreActions();
  const {
    showModal,
    showErrorToast,
    showSuccessToast,
    startLoader,
    stopLoader
  } = useOverlayContext();
  const karbonUsers = useStore(selectors.integration.karbonUsers);
  const renderCard = (text, action) => /*#__PURE__*/_jsx(Card, {
    autoHeight: true,
    padding: "m",
    children: /*#__PURE__*/_jsxs("div", {
      className: styles.cardContent,
      children: [text, action]
    })
  });
  useOnMount(() => {
    if (pmName === PracticeManagement.Karbon) fetchKarbonUsers();
  });
  async function disconnect() {
    const confirmed = await showModal({
      content: _ref => {
        let {
          dismissModal
        } = _ref;
        const cancel = () => dismissModal(false);
        return /*#__PURE__*/_jsx(ConfirmationModal, {
          "data-testid": "confirm-disconnect-modal",
          skin: "danger",
          title: "Disconnect from ".concat(getPMDetails(pmName).name),
          content: /*#__PURE__*/_jsxs(Typography, {
            children: ["Are you sure you want to disconnect from ", getPMDetails(pmName).name, "?"]
          }),
          primaryButtonLabel: "Disconnect",
          secondaryButtonLabel: "Cancel",
          onPrimaryButtonClick: () => dismissModal(true),
          onSecondaryButtonClick: cancel,
          onCloseButtonClick: cancel
        });
      }
    });
    if (!confirmed) return;
    const disconnectLoader = 'disconnect';
    startLoader(disconnectLoader);
    const result = await handlePromise(doDisconnect());
    if (result.success) {
      await fetchIntegrations();
      goBack();
    } else {
      showErrorToast('Failed to disconnect', 'failed-to-disconnect-toast');
    }
    stopLoader(disconnectLoader);
  }
  async function mapServices() {
    showModal({
      content: p => /*#__PURE__*/_jsx(PMMapServicesModal, _objectSpread({
        pmName: pmName,
        getItems: getItems,
        linkServiceTemplate: linkServiceTemplate,
        getServiceTemplateIntegratedIds: getServiceTemplateIntegratedIds
      }, p))
    });
  }
  function goBack() {
    if (history.length > 1) {
      history.goBack();
    } else {
      history.push(routes.availableApps);
    }
  }
  return /*#__PURE__*/_jsx(Page, {
    "data-testid": testid,
    header: "".concat(getPMDetails(pmName).name, " integration setup"),
    subheader: /*#__PURE__*/_jsxs(_Fragment, {
      children: ["Set up your ", getPMDetails(pmName).name, " account connection.", ' ', /*#__PURE__*/_jsx(ExternalLinkButton, {
        openInNewTab: true,
        href: getPMDetails(pmName).articleLink,
        underline: "none",
        children: "Learn more"
      })]
    }),
    onClickBack: goBack,
    children: /*#__PURE__*/_jsxs("div", {
      className: styles.cards,
      children: [renderCard( /*#__PURE__*/_jsxs(Typography, {
        children: ["Map and assign Anchor services to ", getPMDetails(pmName).name, " items"]
      }), /*#__PURE__*/_jsx(Button, {
        "data-testid": testid && "".concat(testid, "-map-services"),
        className: styles.actionButton,
        onClick: mapServices,
        children: "Map services"
      })), pmName === PracticeManagement.Karbon && karbonUsers && integration && integrationModel.isLinked(integration) && renderCard( /*#__PURE__*/_jsx(Typography, {
        children: "Set a default Work assignee"
      }), /*#__PURE__*/_jsx(Autocomplete, {
        selectOnFocus: true,
        disableClearable: true,
        multiple: false,
        size: "small",
        "data-testid": "default-work-assignee",
        options: karbonUsers,
        getOptionLabel: option => option.name,
        value: karbonUsers.find(user => user.id === integrationModel.karbonDefaultAssignee(integration)),
        textFieldProps: {
          minWidth: '240px'
        },
        onChange: async (e, value) => {
          if (!value || !isPracticeManagementIntegrationItem(value)) return;
          const result = await handlePromise(api.karbon.updateKarbonIntegration(value.id));
          if (result.success) {
            await fetchKarbonIntegration();
            showSuccessToast('Default assignee updated successfully', "karbon-assignee-success-toast");
          } else {
            showErrorToast('Failed to update default assignee', "karbon-assignee-error-toast");
          }
        }
      })), renderCard( /*#__PURE__*/_jsxs(Typography, {
        skin: "error",
        children: ["Disconnect from ", getPMDetails(pmName).name]
      }), /*#__PURE__*/_jsx(Button, {
        "data-testid": testid && "".concat(testid, "-disconnect"),
        className: styles.actionButton,
        skin: "danger",
        onClick: disconnect,
        children: "Disconnect"
      }))]
    })
  });
}